import { useQuery as useUrqlQuery } from 'urql';
import { beforeYouBuyModalQuery } from './beforeYouBuyModalQuery';
import { usePropertyId } from '../../contexts/PropertyIdContext/PropertyIdContext';
import { isHopefullyDomEnvironment } from '../../helpers/IsHopefullyDomEnvironment';
import { useFeatureRollout } from '@rea-argonaut/experiment';

export const useBeforeYouBuyModalQuery = () => {
  const isClientSideRender = isHopefullyDomEnvironment();
  const toggleBYBLegalDisclaimers = useFeatureRollout('byb_legal_disclaimers').isEnabled();
  const propertyId = usePropertyId();

  const [urqlResult] = useUrqlQuery({
    query: beforeYouBuyModalQuery,
    pause: !isClientSideRender,
    variables: {
      propertyId,
      toggleBYBLegalDisclaimers,
    },
  });

  return urqlResult;
};
